var map = {
	"./common/easing-in-cubic-follow.js": 97,
	"./common/easing-in-cubic.js": 98,
	"./common/easing-in-quart-follow.js": 99,
	"./common/easing-in-quart.js": 100,
	"./common/easing-linear.js": 101,
	"./common/easing-out-cubic.js": 102,
	"./common/easing-out-quart.js": 103,
	"./common/easing-sine-half.js": 104,
	"./common/easing-sine.js": 105,
	"./common/get-velocity.js": 106,
	"./common/handle-command.js": 107,
	"./common/handle-fade-ending.js": 108,
	"./common/handle-forces-ending.js": 109,
	"./common/handle-hitbox-bottom.js": 110,
	"./common/handle-hitbox-right.js": 111,
	"./common/handle-hitbox.js": 112,
	"./common/handle-state.js": 113,
	"./common/handle-timeout-ending.js": 114,
	"./common/remove-entity.js": 115,
	"./common/remove-fade.js": 116,
	"./common/remove-forces.js": 117,
	"./common/remove-hitbox.js": 118,
	"./common/remove-timeout.js": 119,
	"./common/restart.js": 120,
	"./common/setup-camera.js": 156,
	"./common/setup-inputs.js": 155,
	"./common/setup-world.js": 157,
	"./demo/add-character-spritesheet-sad.js": 121,
	"./demo/add-fade.js": 122,
	"./demo/handle-command-down-end.js": 123,
	"./demo/handle-command-down-start.js": 124,
	"./demo/handle-command-left-end.js": 125,
	"./demo/handle-command-left-start.js": 126,
	"./demo/handle-command-right-end.js": 127,
	"./demo/handle-command-right-start.js": 128,
	"./demo/handle-command-up-end.js": 129,
	"./demo/handle-command-up-start.js": 130,
	"./demo/handle-state.js": 131,
	"./demo/handle-timeout-text.js": 132,
	"./demo/load-splash.js": 133,
	"./demo/start-game.js": 134,
	"./demo/trigger-text.js": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;